<template>
	<div class="loginBpx">
		<div class="header">
			<div class="container overflow">
				<img src="../../assets/img/logo2.png" alt="">
<!-- 				<p>
					<router-link to='/'>返回首页</router-link>
				</p> -->
			</div>
			<div class="login">
				<img src="../../assets/img/logo2.png" alt="">
				<h3>救援清单新零售专家 -- 救援服务销售平台</h3>
				<el-form :model="loginObject" status-icon :rules="rules1" ref="loginObject" label-width="100px" class="demo-ruleForm" key="login" v-if='loginShow'>
					<el-form-item label="企业账号:" prop="passpost">
						<el-input v-model="loginObject.passpost" autocomplete="off" placeholder="请输入机构账号"></el-input>
					</el-form-item>
					<el-form-item label="密码:" prop="password">
						<el-input type="password" v-model="loginObject.password" autocomplete="off" placeholder="请输入机构密码"></el-input>
					</el-form-item>
					<el-form-item label="验证码:" prop="code" class="pic_code">
						<el-input v-model="loginObject.code" autocomplete="off" placeholder="请输入验证码"></el-input>
						<img class="code_img" :src="imgCode" @click="init()">
					</el-form-item>
					<el-form-item>
						<el-button class='btn' type="primary" @click="submitForm('loginObject')">登录救援服务平台</el-button>
						<el-button class='btn btn1' @click='loginShow =false'>申请使用</el-button>
            <!-- <el-button class='btn btn1' @click='loginShow =false;modifyShow =true'>修改密码</el-button> -->
					</el-form-item>
				</el-form>
        <el-form :model="modifyObject" status-icon :rules="rules2" ref="modifyObject" label-width="100px" class="demo-ruleForm" key="modify" v-else-if='modifyShow'>
					<el-form-item label="企业账号:" prop="passpost">
						<el-input v-model="modifyObject.passpost" autocomplete="off" placeholder="请输入机构账号"></el-input>
					</el-form-item>
					<el-form-item label="旧密码:" prop="password">
						<el-input type="password" v-model="modifyObject.password" autocomplete="off" placeholder="请输入机构密码"></el-input>
					</el-form-item>
					<el-form-item label="新密码:" prop="newPassword1">
						<el-input type="password" v-model="modifyObject.newPassword1" autocomplete="off" placeholder="请输入机构密码"></el-input>
					</el-form-item>
          <el-form-item label="确认新密码:" prop="newPassword2">
						<el-input type="password" v-model="modifyObject.newPassword2" autocomplete="off" placeholder="请输入机构密码"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button class='btn' type="primary" @click="submitForm1('modifyObject')">确定</el-button>
						<el-button class='btn btn1' @click='loginShow =true;modifyShow =false'>取消</el-button>
					</el-form-item>
				</el-form>
				<el-form :model="ruleForm3"  status-icon :rules="rules3" ref="ruleForm3" label-width="100px" class="demo-ruleForm" key="apply" v-else>
					<el-form-item label="机构名称:" class="is-required" prop="jgName">
						<el-input v-model="ruleForm3.jgName" autocomplete="off" placeholder="请输入机构名称"></el-input>
					</el-form-item>
					<el-form-item label="联系人姓名:" class="is-required" prop="lxrName">
						<el-input v-model="ruleForm3.lxrName" autocomplete="off" placeholder="请输入联系人姓名"></el-input>
					</el-form-item>
					<el-form-item label="联系人电话:" class="is-required" prop="lxrPhone">
						<el-input v-model.number="ruleForm3.lxrPhone" autocomplete="off" placeholder="请输入联系人电话"></el-input>
					</el-form-item>
					<el-form-item label="机构地址:" class="is-required" prop="contact2">
						<el-input v-model.number="ruleForm3.contact2" autocomplete="off" placeholder="请输入机构地址"></el-input>
					</el-form-item>
					<el-form-item label="组织机构代码:">
						<el-input v-model="ruleForm3.lxrCode" autocomplete="off" placeholder="请输入组织机构代码"></el-input>
					</el-form-item>
					<el-form-item label="所属分支机构:">
						<el-select v-model="ruleForm3.lxrFenzhi" class="choose" placeholder="请选择所属分支机构">
							<el-option
							  v-for="item in fenzhiList"
							  :key="item.id"
							  :label="item.name"
							  :value="item.id">
							</el-option>
						  </el-select>
					</el-form-item>
					<el-form-item>
						<el-button class='btn' style='color: white;' type="primary" @click="submitForm2('ruleForm3')">申请使用</el-button>
						<el-button class='btn btn1' @click='loginShow =true'>已有账号，登录救援服务销售平台</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
  import axios from 'axios'
  import { loginFun,applyFor,getFenzhi } from '@/axios/api.js';
  import JsEncrypt from 'jsencrypt';
  import { v4 as uuidv4} from 'uuid';
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入机构账号'));
				} else {
					if (this.loginObject.password !== '') {
						this.$refs.loginObject.validateField('password');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					callback();
				}
			};
			var validatePass3= (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
      };
      
      var modifyPass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入机构账号'));
				} else {
					callback();
				}
      };
      var modifyPass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入原密码'));
				} else {
					callback();
				}
      };
      var modifyPass3 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'));
				} else {
					callback();
				}
      };
      var modifyPass4 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入新密码'));
				} else {
					callback();
				}
			};

			var checklxrPhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('电话不能为空！'));
				}
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字值'));
				} else {
					callback();
				}
			};
			var validatejgName = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入机构名称！'));
				} else {
					callback();
				}
			};
			var validatejgName2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入联系人姓名！'));
				} else {
					callback();
				}
			};
			var validatejgCode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入组织机构代码！'));
				} else {
					callback();
				}
			};
			var validatejgFenzhi = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请选择分支机构！'));
				} else {
					callback();
				}
			};
			var contact2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请选择输入地址！'));
				} else {
					callback();
				}
      };
			return {
				loginObject: {
					passpost: '',
					password: '',
					code: ''
        },
        modifyObject: {
          passpost: '',
          password: '',
          newPassword1: '',
          newPassword2: '',
        },
				rules1: {
					passpost: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
					code: [{
						validator: validatePass3,
						trigger: 'blur'
					}]
        },
        rules2: {
					passpost: [{
						validator: modifyPass,
						trigger: 'blur'
					}],
					password: [{
						validator: modifyPass2,
						trigger: 'blur'
					}],
					newPassword1: [{
						validator: modifyPass3,
						trigger: 'blur'
          }],
          newPassword2: [{
						validator: modifyPass4,
						trigger: 'blur'
					}],
				},
				ruleForm3: {
					jgName: '',
					lxrName: '',
					lxrPhone: '',
					lxrCode:'',
					lxrFenzhi:'',
					contact2:''
				},
				rules3: {
					jgName: [{
						validator: validatejgName,
						trigger: 'blur'
					}],
					lxrName: [{
						validator: validatejgName2,
						trigger: 'blur'
					}],
					lxrPhone: [{
						validator: checklxrPhone,
						trigger: 'blur'
					}],
					lxrCode:[{
						validator:validatejgCode,
						trigger:'blur'
					}],
					lxrFenzhi:[{
						validator:validatejgFenzhi,
						trigger:''
					}],
					contact2:[{
						validator:contact2,
						trigger:''
					}],
				},
        loginShow: true,
        modifyShow: false,
        fenzhiList:[],
        imgCode: '',
        publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYkZgWwtAMghBA9Rz6WzFVkrr2q8cgdmodecIrMBYrNPuvH3Gi/hAwxYwbm1tM+97SSh75/xn5kOozGEXI6LUI5ETVuJ8cd3xaPgUABp1m2iCWIXrj8F2nQiniRthoyu4Ibkrhm8y/X2D8kSw4odmvGuC1w2lh7AyDcNrvSfL7KQIDAQAB',
        local_session: ''
			};
    },
    created:function(){
      this.init();
    },
	  methods: {
      /* 密码要求有 数字、字母 特殊字符 3种 的组合,
      * 密码最小长度最少要求有8位
      * 新密码中不能够包含帐户。
      */
      passwordValid(userName, pass) {
        let passLower = pass.toLocaleLowerCase();
        let flag = " ";
        if (
          pass === null ||
          pass.length < 8 ||
          pass.length === ""
        ) {
          flag = "密码位数不对，长度最少8位";
          return flag;
        }
        // 是数字
        let isDigit = /^.*[0-9]+.*/;
        // isLowerCase 字母
        let isLowerCase = /^.*[a-zA-Z]+.*/;
        // 特殊字符
        let regEx = /^.*[^a-zA-Z0-9]+.*/;
        // 记录匹配的次数
        let num = 0;
        if (isDigit.test(pass)) {
          num = num + 1;
        }
        if (isLowerCase.test(pass)) {
          num = num + 1;
        }
        if (regEx.test(pass)) {
          num = num + 1;
        }
        if (num <= 2) {
          flag ="密码复杂度不足,\n需包含字母、数字和特殊字符这三种字符";
          return flag;
        }
        //新密码中不能够包含帐户。
        if (pass.indexOf(userName) >= 0) {
          flag = "密码不能包含用户名";
          return flag;
        }
        return "correct";
      },
      init(){
        if (!sessionStorage.getItem('local_session')) {
          this.local_session = uuidv4();
          sessionStorage.setItem('local_session', this.local_session)
        } else {
          this.local_session = sessionStorage.getItem('local_session');
        }
        axios.get(SEVERS + 'rescue_sale/user/generateValidateCode?local_session=' + this.local_session)
      		.then(res => {
      		  this.imgCode = res.data
      		})
      		.catch(err => {
      			console.log(err)
      		})
      },
      /*密码加密规则*/
      RSAencrypt(pas) {
        let jse = new JsEncrypt();
        jse.setPublicKey(this.publicKey);
        return jse.encrypt(pas);
      },
			submitForm(formName) {
				var data = {
					passport: this.loginObject.passpost,
					password:this.RSAencrypt(this.loginObject.password),
          imageValidCode: this.loginObject.code,
          local_session: this.local_session
        }
				this.$refs[formName].validate((valid) => {
					if (valid) {
						loginFun(data)
							.then(res => {
								if (res.data.code == 0) {
                  localStorage.setItem("channelId", res.data.obj2.channelId);
                  localStorage.setItem("prestore", res.data.obj2.prestore);
									if(res.data.obj.contractStatus == 0){
										window.location.href=SEVERS+'rescue_sale/user/toXieyi?token='+res.data.obj.token
									}else if(!res.data.obj.token){
										this.$router.push({
											path:'/towait',
											query:{
												channelId:res.data.obj.channelId,
												state:3
											}
										})
									}else{
										if(res.data.obj2.status == 3){
											this.$router.push({
												path:'/towait?state=3'
											})
										}else if(res.data.obj2.status == 4){
											this.$router.push({
												path:'/towait?state=4'
											})
										}
										window.localStorage.setItem(
											"token",
											JSON.stringify({
												data: res.data
											})
										);
										this.$router.push({
											path:'/shop'
										})
                  }
								} else {
									this.$message({
										message: res.data.msg,
										type: "error"
                  });
                  if (res.data.code != 109001) {
                    this.init()
                  }
								}
							})
							.catch(err => {
                this.init()
								console.log(err)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
      },
      submitForm1() {
        if (this.modifyObject.newPassword1 != this.modifyObject.newPassword2) {
          this.$message({
            message: "两次密码输入不一致",
            type: "error"
          });
          return false;
        } else if (this.modifyObject.newPassword1 == this.modifyObject.password) {
          this.$message({
            message: "新密码不能与原密码相同",
            type: "error"
          });
          return false;
        } else if (this.passwordValid(this.modifyObject.passpost,this.modifyObject.newPassword1) != "correct") {
          this.$message({
            message: this.passwordValid(this.modifyObject.passpost,this.modifyObject.newPassword1),
            type: "error"
          });
          return false;
        } 
				var data = {
					passport: this.modifyObject.passpost,
          password:this.RSAencrypt(this.modifyObject.password),
          newPassword1:this.RSAencrypt(this.modifyObject.newPassword1),
          newPassword2:this.RSAencrypt(this.modifyObject.newPassword2)
        }
				this.$refs[formName].validate((valid) => {
					if (valid) {
						loginFun(data)
							.then(res => {
								if (res.data.code == 0) {
                  loginShow =true;
                  modifyShow =false;
                } else {
                  this.$message({
										message: res.data.msg,
										type: "error"
                  });
                }
							})
							.catch(err => {
								console.log(err)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
      },
			submitForm2(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.applyFor()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			applyFor(){
				var data={
					name:this.ruleForm3.jgName,
					contactName:this.ruleForm3.lxrName,
					contact1:this.ruleForm3.lxrPhone,
					orgCode:this.ruleForm3.lxrCode,
					parentId:this.ruleForm3.lxrFenzhi,
					contact2:this.ruleForm3.contact2
				}
				applyFor(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 100000){
						this.$message({
						  message: '申请成功，请您耐心等待我们后台审核通过！',
						  type: 'success'
						});	
						this.$refs['ruleForm3'].resetFields();			
					}
				})
				.catch( err => {
					console.log(err)
				})				
			},
			getFenzhi(){
				getFenzhi().then(res =>{
					if(res.data.code==0){
						this.fenzhiList=res.data.obj;
					}
				})
				.catch( err => {
					console.log(err)
				})
			}
    },
		mounted() {
      var data =JSON.parse(localStorage.getItem('token'));
      this.severs = SEVERS;
      if(data){
        var token=data.data.obj.token
      }
      if(token){
        window.location.href='#/shop'
      }      
			if(this.$route.query.status == 1){
				this.loginShow=false
			}
			this.getFenzhi();
		}
	}
</script>

<style scoped="scoped">
	.pic_code .el-input{
    width: 70%!important;
  }
  .pic_code .code_img{
    width: 25%;
    height: 40px;
    float: right;
    cursor: pointer;
  }
	.loginBpx {
		width: 100vw;
		height: 100vh;
		background: url(../../assets/img/login.png) left top no-repeat;
		background-size: 100% 100%;
		position: relative;
	}
	.header {
		background-color: white;
		height: 70px;
	}
	.container img {
		float: left;
		height: 40px;
		margin-top: 15px;
	}
	.container p {
		float: right;
		line-height: 70px;
	}
	.login {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 600px;
		margin-left: -300px;
		margin-top: -315px;
		background: white;
		padding: 20px;
	}
	.login img {
		margin: 0 auto;
		display: block;
	}
	.login h3 {
		text-align: center;
		line-height: 40px;
		color: #00ABFA;
		margin-bottom: 20px;
	}
  .modify{
    float: right;
    cursor: pointer;
    color: #666;
  }
	.demo-ruleForm {
		width: 500px;
	}
	.btn {
		display: block;
		width: 100%;
		margin: 0 auto;
		margin-bottom: 20px;
		margin-top: 10px;
	}
	.choose{
		width: 100%;
	}
	.btn1{margin-left: auto !important;}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue